import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Deals = Loadable(lazy(() => import('./deals')));

const dealsRoutes = [
  { path: '/dashboard/deals', element: <Deals />, auth: authRoles.admin },
];

export default dealsRoutes;
